// The only place an ATM origin is spelled out (lint-enforced).
// `development` (vercel env pull) and unset (Jest, next dev) both mean localhost.

type Tier = 'production' | 'preview' | 'local'

const env = process.env.NEXT_PUBLIC_VERCEL_ENV
const tier: Tier = env === 'production' || env === 'preview' ? env : 'local'

const MARKETING_ORIGINS: Record<Tier, string> = {
  production: 'https://www.atm.com',
  preview: 'https://web.stage.atm-aws.com',
  local: 'http://localhost:2001',
}

const APP_ORIGINS: Record<Tier, string> = {
  production: 'https://app.atm.com',
  preview: 'https://app.stage.atm-aws.com',
  local: 'http://localhost:2000',
}

// Self-hosted ChatKit server (atm-com/chatkit-server, EKS).
const CHATKIT_ORIGINS: Record<Tier, string> = {
  production: 'https://chat.atm.com',
  preview: 'https://chat.stage.atm-aws.com',
  local: 'http://localhost:4322',
}

// Backend services host. Local dev uses stage: the ChatKit session it mints
// must be one the stage chat server accepts.
const SERVICES_ORIGINS: Record<Tier, string> = {
  production: 'https://services.atm.com',
  preview: 'https://services.stage.atm-aws.com',
  local: 'https://services.stage.atm-aws.com',
}

// www is primary; the apex redirects to it (Vercel domain setting).
export const MARKETING_ORIGIN = MARKETING_ORIGINS[tier]
export const APP_ORIGIN = APP_ORIGINS[tier]

export function marketingUrl(path = ''): string {
  return `${MARKETING_ORIGIN}${path}`
}

export function appUrl(path = ''): string {
  return `${APP_ORIGIN}${path}`
}

export function chatkitServerUrl(): string {
  return `${CHATKIT_ORIGINS[tier]}/chatkit`
}

// Mints the session tokens chatkitServerUrl() accepts.
export function chatkitSessionUrl(): string {
  return `${SERVICES_ORIGINS[tier]}/chatkit/session`
}

// /sign-up forwards the website's host-only utm cookie; skipping it loses attribution.
export function signUpUrl(): string {
  return marketingUrl('/sign-up')
}

// Always production: canonical, og:url, JSON-LD, sitemap. Stage points at prod.
export function canonicalMarketingUrl(path = ''): string {
  return `${MARKETING_ORIGINS.production}${path}`
}

export function canonicalAppUrl(path = ''): string {
  return `${APP_ORIGINS.production}${path}`
}
